import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../../../../config/config.service';

@Injectable({
  providedIn: 'root'
})
export class CustodepreciacaoService {

  constructor(private httpClient: HttpClient, private configService: ConfigService) { }

  getDepreciacoesCusto(page: number, size: number, sortField: string, sortDirection: string, instancias: string, dataInicio: string, dataFim: string){
    return this.httpClient.get<any>(`${this.configService.getApiUrlRoot()}/custos/depreciacoes?page=${page}&size=${size}&instancias=${instancias}&dataInicio=${dataInicio}&dataFim=${dataFim}`);
  }
}
